module.exports = __webpack_public_path__ + "static/media/R_AoA_RaceGameEnvShot_01.25c7856d.jpg";